import { RelatorioComposicaoContasPdfResponse } from "core/features/relatorios/conta-com-composicoes/typings";
import { PDFLayout } from "ui/components/PDF";
import { formatMoney } from "infra/helpers/number";
import ItemTable from "./components/ItemTable/index";
import { View } from "@react-pdf/renderer";
import colors from "theme/colors";
import TotalRow from "./components/TotalRow/index";
import ResumoPorCategoria from "components/Relatorio/ResumoPorCategoria";
import { OperacaoEnum } from "resources/enums/conta";
import { PDFHeaderProps } from "./../../../PDF/Header";
import { RelatorioContasComComposicaoFields } from "core/features/relatorios/typings";

interface PDFRelatorioComposicaoContasProps {
  data?: RelatorioComposicaoContasPdfResponse;
  includeDocumentWrapper?: boolean;
  operacao: OperacaoEnum;
  fields?: RelatorioContasComComposicaoFields[];
}

function PDFRelatorioComposicaoContas({
  data,
  includeDocumentWrapper = true,
  operacao,
  fields,
}: PDFRelatorioComposicaoContasProps) {
  const cards: PDFHeaderProps["cards"] = [
    {
      title: "Total",
      value: formatMoney(data?.valorTotal),
      alignItems: "flex-end",
    },
  ];

  if (operacao === OperacaoEnum.Receita) {
    cards.unshift({
      title: "Unidades",
      value: data?.totalUnidades?.toString() || "",
      alignItems: "flex-end",
    });
  }

  return (
    <PDFLayout
      includeDocument={includeDocumentWrapper}
      fontSize={7}
      assinaturas={data?.assinaturas}
      orientation="landscape"
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Relatório de ${
          operacao === OperacaoEnum.Despesa ? "despesas" : "receitas"
        } com composição`,
        subTitle: data?.periodo,
        cards,
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      {data?.items.map((item, index) => (
        <View
          key={`${item.blocoQuadra}-${item.unidade}-${item.nome}`}
          style={{ marginBottom: index < data?.items.length - 1 ? 8 : 6 }}
        >
          <ItemTable operacao={operacao} item={item} fields={fields} />
        </View>
      ))}

      {data ? (
        <View
          style={{
            borderTopColor: colors.primary,
            borderTopWidth: 2,
            paddingTop: 2,
            fontWeight: "medium",
          }}
        >
          <TotalRow title={`Total`} valorTotal={data.valorTotal} />
        </View>
      ) : null}

      {data && fields?.includes("resumoContaCategoria") ? (
        <View
          style={{
            marginTop: 32,
          }}
        >
          <ResumoPorCategoria data={data} />
        </View>
      ) : null}
    </PDFLayout>
  );
}

export default PDFRelatorioComposicaoContas;
